import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';
import { AnalyticsModal } from '@atom/types/analytics';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import classes from './analyticsDetail.module.css';

interface Props {
  name: string;
  setActiveModal: (modal: AnalyticsModal) => void;
  loading: boolean;
}

const AnalyticsHeader = ({ name, setActiveModal, loading }: Props) => {
  const [, { navigate }] = useNavigation();

  const navigateBack = (): void => {
    navigate('/analytics/dashboard');
  };

  return (
    <div className={classes.headerContainer}>
      <IconButton onClick={navigateBack}>
        <Icon color={colors.neutral.white}>arrow_back</Icon>
      </IconButton>
      <div>{name}</div>
      {hasRolePermissions(ROLE_SETS.ORG_ADMIN) && (
        <div className={classes.headerButtons}>
          <IconButton
            disabled={loading}
            onClick={() => !loading && setActiveModal(AnalyticsModal.UPDATE)}
            data-cy="analyticsDetailEditCardIcon"
          >
            <Icon color={loading ? colors.neutral.dim : colors.neutral.white}>
              edit
            </Icon>
          </IconButton>
          <IconButton
            disabled={loading}
            onClick={() => !loading && setActiveModal(AnalyticsModal.DELETE)}
            data-cy="analyticsDetailDeleteCardIcon"
          >
            <Icon color={loading ? colors.neutral.dim : colors.neutral.white}>
              delete
            </Icon>
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default AnalyticsHeader;
